import React, {useEffect} from "react";

const TermsOfService = () => {
  useEffect(() => {
            document.title = "Terms of Service - Senior Vault Capital"; // Changed title
          }, []);
  return (
    <div className="bg-[#ffffff] min-h-screen flex items-center justify-center">
      <section className="max-w-6xl w-full mx-auto px-6 sm:px-10 lg:px-16 py-28 text-center">
        {/* Header */}
        <header className="my-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-[#000300] mb-4">
             Senior Vault Capital Terms Of Service
          </h1>
          <p className="text-lg text-gray-600">Effective Date: January 11, 2025</p>
        </header>

        {/* Content */}
        <div className="grid grid-cols-1 gap-10 text-[#000300]">
          {sections.map(({ title, content }, index) => (
            <section key={index} className="text-left">
              <h2 className="lg:text-2xl sm:text-3xl font-semibold text-[#000300] mb-4">
                {title}
              </h2>
              {Array.isArray(content) ? (
                <ul className="list-disc pl-6 space-y-2 lg:text-lg">
                  {content.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              ) : (
                <p className="lg:text-lg">{content}</p>
              )}
            </section>
          ))}

          {/* Contact Section */}
          <section className="text-left">
            <h2 className="text-2xl sm:text-3xl font-semibold text-[#000300] mb-4">
              Contact Us
            </h2>
            <p>
              If you have any questions or concerns regarding these terms, please contact us:
            </p>
            <p className="font-semibold text-[#000300]">Email: support@seniorvaultcapital.com</p> {/* Changed email */}
          </section>
        </div>

        {/* Footer */}
        <footer className="pt-12 text-center">
          <p className="text-sm sm:text-base font-semibold text-[#000300]">
            By engaging with Senior Vault Capital, you acknowledge that you've read, understood, and accepted these Terms and Conditions.
          </p>
        </footer>
      </section>
    </div>
  );
};

const sections = [
  {
    title: "Introduction",
    content:
      "These Terms and Conditions outline the scope of services, responsibilities, and risks associated with our investment management services. Please read this document carefully before engaging with Senior Vault Capital.",
  },
  {
    title: "Scope of Services",
    content: [
      "Senior Vault Capital provides investment management services, including:",
      "Investment advice",
      "Portfolio management",
      "Financial planning"
    ],
  },
  {
    title: "Investment Risks",
    content:
      "Investing involves risk, including the potential for loss. You acknowledge and accept this risk, understanding that past performance is not a guarantee of future results.",
  },
  {
    title: "Limitations of Liability",
    content:
      "Senior Vault Capital will not be held liable for losses or damages resulting from investment decisions, market fluctuations, or factors beyond our control.",
  },
  {
    title: "Client Responsibilities",
    content: [
      "Providing accurate and complete information",
      "Updating your personal and financial circumstances",
      "Notifying us of any changes"
    ],
  },
  {
    title: "Confidentiality",
    content:
      "We maintain client confidentiality and protect your personal and financial information.",
  },
  {
    title: "Changes to Terms and Conditions",
    content:
      "We may update these Terms and Conditions periodically. We'll notify you of significant changes.",
  },
  {
    title: "Governing Law",
    content:
      "These Terms and Conditions are governed by and construed in accordance with the laws of the United States and the State of Washington.",
  },
  {
    title: "Acceptance",
    content:
      "By engaging with Senior Vault Capital, you acknowledge that you've read, understood, and accepted these Terms and Conditions.",
  },
];

export default TermsOfService;